import "styles/elements/Texture.scss";
import { ClassName } from "types";
import clsx from "clsx";

function Texture({ className }: ClassName) {
  return <span className={clsx("texture", className)} />;
}

export default Texture;
